import {
  GET_PLANS,
  CREATE_PLANS,
  DELETE_PLANS,
  UPDATE_PLANS,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
} from "./actionType";

// common success
export const PlansApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const PlansApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const Plans = (id) => ({
  type: GET_PLANS,
  payload: { id },
});

export const CreatePlans = (data) => ({
  type: CREATE_PLANS,
  payload: { data },
});

export const UpdatePlans = (id, data) => ({
  type: UPDATE_PLANS,
  payload: { id, data },
});

export const DeletePlans = (id) => ({
  type: DELETE_PLANS,
  payload: { id },
});
